export default {"src":"/_next/static/media/0xd4cb328a82bdf5f03eb737f37fa6b370aef3e888.f246cf38.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};